// componentRegistry.js
// Central registry for all components that can be dynamically rendered

import {
  Textarea,
  EditableText,
  LabelledField,
  LabelledArea,
  LabelledCom,
  JSONEditor,
  Img,
  Invoice,
  CheckBox,
  ImageSection,
  Typo,
  ImageIcon,
  ImageIconGrid,
  Background,
  HTML,
  SearchableList,
  TwinSearchableLists,
  Dock,
  TextInput,
  EmailInput,
  PasswordInput,
  NumberInput,
  TextAreaInput,
  Checkbox,
  Radio,
  Select,
  DateInput,
  TimeInput,
  FileInput,
  RangeInput,
  ColorInput,
  HiddenInput,
  VisibilityContainer,
  Tabs,
  Form,
  InfiniteList,
  RadialLayout,
  Cloneable,
  JSXEditor,
  JSXList,
  StackList,
  StackItem,
  StackContainer,
  SmartIcon,
  Text,
  SVGPathAnimator,
  Target,
  QwanyxContext, // Importez le QwanyxContext directement
  CardContainer,
  Window,
  GroupContainer,
  PersistQwantum,
  DNDEditor,
  MarkdownDisplay,
  Shop,
  Requests,
  RequestButton,
  Website,
  //WorldTest
} from "qwanyx";

// Import JSX wrapper components
import {
  StateWrapper,
  EffectWrapper,
  RefWrapper,
  MemoWrapper,
  CallbackWrapper,
  TimerWrapper,
  AnimationWrapper,
  FetchWrapper,
  FormWrapper,
  LocalStorageWrapper
} from "./warpers/JSXWrappers";

import {
  createNamedContext,
  ContextProvider,
  ContextConsumer,
  UseContext,
  StateContextProvider,
  contextRegistry // Importez le contextRegistry
} from "./warpers/ContextWarpers";

// Enregistrez le QwanyxContext dans le registry
contextRegistry['qwanyxContext'] = {
  context: QwanyxContext,
  defaultValue: null
};

// Lazy-loaded component map
// Components will only be imported when needed
export const componentRegistry = {
  get Textarea() { return Textarea; },
  get EditableText() { return EditableText; },
  get LabelledField() { return LabelledField; },
  get LabelledArea() { return LabelledArea; },
  get LabelledCom() { return LabelledCom; },
  get JSONEditor() { return JSONEditor; },
  get Img() { return Img; },
  get Invoice() { return Invoice; },
  get CheckBox() { return CheckBox; },
  get ImageSection() { return ImageSection; },
  get Typo() { return Typo; },
  get ImageIcon() { return ImageIcon; },
  get ImageIconGrid() { return ImageIconGrid; },
  get Background() { return Background; },
  get HTML() { return HTML; },
  get SearchableList() { return SearchableList; },
  get TwinSearchableLists() { return TwinSearchableLists; },
  get Dock() { return Dock; },
  get TextInput() { return TextInput; },
  get EmailInput() { return EmailInput; },
  get PasswordInput() { return PasswordInput; },
  get NumberInput() { return NumberInput; },
  get TextAreaInput() { return TextAreaInput; },
  get Checkbox() { return Checkbox; },
  get Radio() { return Radio; },
  get Select() { return Select; },
  get TimeInput() { return TimeInput; },
  get FileInput() { return FileInput; },
  get RangeInput() { return RangeInput; },
  get ColorInput() { return ColorInput; },
  get HiddenInput() { return HiddenInput; },
  get VisibilityContainer() { return VisibilityContainer; },
  get DateInput() { return DateInput; },
  get Tabs() { return Tabs; },
  get Form() { return Form; },
  get InfiniteList() { return InfiniteList; },
  get RadialLayout() { return RadialLayout; },
  get Cloneable() { return Cloneable; },
  get JSXEditor() { return JSXEditor; },
  get JSXList() { return JSXList; },
  get StackList() { return StackList; },
  get StackItem() { return StackItem; },
  get StackContainer() { return StackContainer; },
  get SmartIcon() { return SmartIcon; },
  get Text() { return Text; },
  get SVGPathAnimator() { return SVGPathAnimator; },
  get Target() { return Target; },
  get CardContainer() { return CardContainer; },
  get Window() { return Window; },
  get GroupContainer() { return GroupContainer; },
  get DNDEditor() { return DNDEditor; },
  get MarkdownDisplay() { return MarkdownDisplay; },
  get Shop() { return Shop; },
  get Requests() { return Requests; },
  get RequestButton() { return RequestButton; },
  get Website() { return Website; },
 // get WorldTest() { return WorldTest; },


  // Add JSX wrapper components
  get StateWrapper() { return StateWrapper; },
  get EffectWrapper() { return EffectWrapper; },
  get RefWrapper() { return RefWrapper; },
  get MemoWrapper() { return MemoWrapper; },
  get CallbackWrapper() { return CallbackWrapper; },
  get TimerWrapper() { return TimerWrapper; },
  get AnimationWrapper() { return AnimationWrapper; },
  get FetchWrapper() { return FetchWrapper; },
  get FormWrapper() { return FormWrapper; },
  get LocalStorageWrapper() { return LocalStorageWrapper; },

  // Context Warpers
  get createNamedContext() { return createNamedContext; },
  get ContextProvider() { return ContextProvider; },
  get ContextConsumer() { return ContextConsumer; },
  get UseContext() { return UseContext; },
  get StateContextProvider() { return StateContextProvider; },

  //Persistance
  get PersistQwantum() { return PersistQwantum; },
};

// Add a function to register the Card component once it's defined
// (Resolves circular dependency)
export const registerCardComponent = (CardComponent) => {
  Object.defineProperty(componentRegistry, 'Card', {
    get: () => CardComponent,
    configurable: true
  });
};